var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-body"},[_c('div',{staticClass:"chat-messages custom-scrollbar"},[_c('Received'),_c('Sender')],1),_c('Message')],1)}
var staticRenderFns = []

export { render, staticRenderFns }